module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('panel', {
    attrs: {
      "title": "Categoria"
    }
  }, [_c('loader', {
    attrs: {
      "loading": _vm.loading
    }
  }), _vm._v(" "), (_vm.categoryNotFound) ? _c('div', {
    staticClass: "hint hint--left icon-category-not-found",
    attrs: {
      "slot": "header-right",
      "data-label": "Não foi possível utilizar a predefinição configurada, por favor acesse as predefinições e realize a correção no item indicado."
    },
    slot: "header-right"
  }, [_c('i', {
    staticClass: "icon-warning2 t-warning"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "l-row"
  }, _vm._l((_vm.categories), function(categories, index) {
    return _c('form-group', {
      key: categories,
      attrs: {
        "label": ((_vm.$t('category.label')) + " " + (_vm.$t('level.label')) + " " + ((index + 1))),
        "columns": 4,
        "error": _vm.product.categories[index] === null && _vm.getError('categories', _vm.product.productId)
      }
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product.categories[index]),
        expression: "product.categories[index]"
      }],
      staticClass: "form-select",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.product.categories, index, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.getCategoryChildren(index)
        }]
      }
    }, [_c('option', {
      domProps: {
        "value": null
      }
    }, [_vm._v(_vm._s(_vm.$t('choose.label')))]), _vm._v(" "), _vm._l((categories), function(category) {
      return _c('option', {
        key: category,
        domProps: {
          "value": category.id
        }
      }, [_vm._v(_vm._s(category.name))])
    })], 2)])
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3494600d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marketplace/mercadoLivre/announcement/general/Category.vue
// module id = 3043
// module chunks = 0